/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FiscalYearConfiguration {
    getFixupPrototypeFunction() { return FiscalYearConfiguration.fixupPrototype; }

    static newInstance(model: Partial<FiscalYearConfiguration>): FiscalYearConfiguration {
        let obj = Object.assign(new FiscalYearConfiguration(), model);
        FiscalYearConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FiscalYearConfiguration>): FiscalYearConfiguration {
        if (!model) return null;
        return FiscalYearConfiguration.newInstance(<FiscalYearConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FiscalYearConfiguration) {
        if (!obj) return;

        models.FiscalYearConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FiscalYearConfiguration): boolean {
        Object.setPrototypeOf(obj, FiscalYearConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Start Date for Financial Year in DD-MMM format
     */
    start: string;

    /**
     * End Date for Financial Year in DD-MMM format
     */
    end: string;

}
